import { __ } from '@wordpress/i18n';
import { useBlockProps, RichText, InspectorControls } from '@wordpress/block-editor';
import {
  TextControl,
  __experimentalToggleGroupControl as ToggleGroupControl,
  __experimentalToggleGroupControlOption as ToggleGroupControlOption,
} from '@wordpress/components';
import PanelBody from '../../components/PanelBody';
import './style.scss';

/**
 * The editor shows the button in its resting state. It cannot show the loading
 * state or the end of the results, because both depend on a query that only
 * runs on the front end.
 */
export default function Edit({ attributes, setAttributes }) {
  const { label, loadingLabel, align } = attributes;

  const blockProps = useBlockProps({
    className: `brandy-load-more is-aligned-${align}`,
  });

  return (
    <>
      <InspectorControls>
        <PanelBody title={__('Button', 'brandy-blocks')} initialOpen>
          <ToggleGroupControl
            label={__('Alignment', 'brandy-blocks')}
            value={align}
            onChange={(next) => setAttributes({ align: next })}
            isBlock
            __nextHasNoMarginBottom
          >
            <ToggleGroupControlOption value="left" label={__('Left', 'brandy-blocks')} />
            <ToggleGroupControlOption value="center" label={__('Center', 'brandy-blocks')} />
            <ToggleGroupControlOption value="right" label={__('Right', 'brandy-blocks')} />
          </ToggleGroupControl>

          <TextControl
            label={__('Loading label', 'brandy-blocks')}
            help={__('Shown while the next page is on its way.', 'brandy-blocks')}
            value={loadingLabel}
            onChange={(next) => setAttributes({ loadingLabel: next })}
            __nextHasNoMarginBottom
          />
        </PanelBody>
      </InspectorControls>

      <div {...blockProps}>
        <RichText
          tagName="span"
          className="brandy-load-more__button"
          value={label}
          onChange={(next) => setAttributes({ label: next })}
          placeholder={__('Load more', 'brandy-blocks')}
          allowedFormats={[]}
        />
      </div>
    </>
  );
}
